export function shouldShowDiscrepancyInfo(documentDiscrepancy) {
  if (!documentDiscrepancy || documentDiscrepancy.discrepancies.length === 0) {
    return false;
  }
  if (documentDiscrepancy.type === 'passport_discrepancy') {
    return true;
  }
  if (documentDiscrepancy.type === 'ielts_discrepancy') {
    return true;
  }
  return false;
}